import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Measure from 'react-measure'

const styles = {
  measuringArea: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    visibility: 'hidden'
  }
}

export default class ConditionalSizeRender extends Component {
  static propTypes = {
    compareFn: PropTypes.func,
    children: PropTypes.node,
    measuringAreaStyle: PropTypes.object
  }
  constructor() {
    super()
    this.state = {
      firstChildDimensions: {},
      secondChildDimensions: {}
    }
  }
  renderSelectedChild = () => {
    const compareFn = this.props.compareFn || this.selectLowestHeightChild
    if (!this.state.firstChildDimensions || !this.state.secondChildDimensions) {
      return null
    }
    return compareFn({ ...this.state }) ? this.props.children[0] : this.props.children[1]
  }

  selectLowestHeightChild = () =>
    this.state.firstChildDimensions.height < this.state.secondChildDimensions.height

  render() {
    return (
      <div
        data-test="conditional-layout"
        style={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <div style={styles.measuringArea}>
          <Measure
            onResize={({ entry }) => {
              const { height, width } = entry
              this.setState({ firstChildDimensions: { height, width } })
            }}>
            {({ measureRef }) => <div ref={measureRef}>{this.props.children[0]}</div>}
          </Measure>
          <Measure
            onResize={({ entry }) => {
              const { height, width } = entry
              this.setState({ secondChildDimensions: { height, width } })
            }}>
            {({ measureRef }) => <div ref={measureRef}>{this.props.children[1]}</div>}
          </Measure>
        </div>
        {this.renderSelectedChild()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/conditional-layout/index.jsx